/**
 * Add drag ability to a model
 */
import store from '@/store/store';
import { TYPE, EVENTSTATUS } from '@/constants';
import SVG from 'svg.js';
import Application from '../application';

export interface DraggableRequirements {
  attributes: Record<string, any>;
  view: SVG.G;
  app: Application;
  type: (typeof TYPE)[keyof typeof TYPE];
  moveShapes(x: number, y: number): void;
}

export const DraggableMixin = <T extends { new (...args: any[]): DraggableRequirements }>(base: T) => {
  return class DraggableMixin extends base {
    startX: number | undefined;
    startY: number | undefined;

    checkIfDraggable() {
      if (!this.app.props.options.modes.map((s) => s.toLowerCase()).includes('drawing')) return false;
      let draggable = true;
      if (this.type === TYPE.SEAT || this.type === TYPE.TABLE || this.type === TYPE.TABLESEAT) {
        if (this.app.props.status === EVENTSTATUS.PUBLISHED) {
          draggable = false;
        }
      }
      if (this.attributes.canBeDraggable !== undefined && !this.attributes.canBeDraggable) {
        draggable = false;
      }
      draggable = !store.state.seatmap.isDraggable ? false : draggable;
      return draggable;
    }

    onDragStart() {
      if (this.checkIfDraggable()) {
        this.startX = this.view.x();
        this.startY = this.view.y();
      }
    }

    onDragMove(dx: number, dy: number) {
      if (this.checkIfDraggable()) {
        const x = this.startX! + dx;
        const y = this.startY! + dy;
        this.move(x, y);
      }
    }

    onDragEnd() {
      if (this.checkIfDraggable()) {
        if (this.type === TYPE.SEAT) {
          const p = this.attributes.position;
          const { x, y } = new SVG.Point(p).transform(this.view.transform('matrix' as any) as unknown as SVG.Matrix);
          this.attributes.position = [x, y];
          this.moveShapes(x, y);
          this.view.untransform();
        } else if (this.type === TYPE.TABLE) {
          const p = this.attributes.position;
          const { x, y } = new SVG.Point(p).transform(this.view.transform('matrix' as any) as unknown as SVG.Matrix);
          this.view.untransform();
          this.updatePosition(x, y);
        }
        delete this.startX;
        delete this.startY;
      }
    }

    move(x: number, y: number, relative = false) {
      this.view.transform({ x, y }, relative);
    }

    updatePosition(x: number, y: number) {
      throw new Error('Method not implemented.');
    }
  };
};
